<template>
  <div class="col-md-3">
    <form-group-select
      v-if="options"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      placeholder="Selecione"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import NacionalidadeService from "../../../domain/corpore/NacionalidadeService";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-nacionalidade",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  asyncComputed: {
    options() {
      this.service = new NacionalidadeService(this.$resource);
      return this.service.getNacionalidades().then(nacionalidades => {
        return nacionalidades.map(nacionalidade => {
          return {
            value: nacionalidade.codigo,
            text: nacionalidade.descricao
          };
        });
      });
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/Nacionalidade.vue